import { styles } from "@/pages/Settings/stylesSettings";
import { Box, Avatar, Typography } from "@mui/material";

type Props = {
  name: string;
  username: string;
  avatarUrl: string;
  onClick?: () => void;
};

const MentorResultItem = ({ avatarUrl, username, onClick }: Props) => {
  return (
    <Box sx={styles.resultItem} onClick={onClick}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Avatar src={avatarUrl} sx={styles.avatar} />
        <Box>
          <Typography sx={styles.mentorUsername}>@{username}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MentorResultItem;
